<template>
  <van-popup v-model:show="show" class="full-height min-w-screen !overflow-hidden">
    <full-page-loader :loading="isLoading"/>
    <div class="flex items-center px-3 gap-2 sticky top-0 bg-white z-1">
      <van-icon class="flip-icon van-gray-6" name="arrow-left" size="22" @click="closeSearch"></van-icon>
      <niceone-search ref="searchRef" v-model="search" :placeholder="$t('search.search')"
                      :show-action="!!search"
                      class="rounded-full w-full"
                      @search="searchWord">
        <template #left-icon>
          <niceone-image :src="$publicPath('/images/header/search.svg')" width="24"/>
        </template>
        <template #action>
          <span></span>
        </template>
      </niceone-search>
      <div @click="cancelHandler" class="font-niceone-medium">{{ $t('common.cancel') }}</div>
    </div>
    <div class="h-full flex-1 overflow-y-auto">
      <search-list v-if="!isLoading && search" :search="search" @close="show = false"/>
      <div v-if="!isLoading && !search" class="p-3">
        <stored-searched-word @closeSearch="closeSearch" @setSearch="setSearch"/>
        <popular-search-words :trends="trends" @setSearch="setSearch"/>
        <brand-section :trends="trends"/>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import {getSearchTrends} from "@/plugins/API/search"
import SearchList from "@/components/home/SearchList"
import StoredSearchedWord from "@/components/home/StoredSearchedWord"
import PopularSearchWords from "@/components/home/PopularSearchWords"
import BrandSection from "@/components/home/BrandSection"
import {recentSuggestionWord} from "@/composables/useStoreWord";
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  initialValue: {
    type: String,
    default: ''
  }
})

const searchRef = ref(null)
onMounted(() => {
  searchRef.value?.focus();
})

const emit = defineEmits(['update:modelValue'])

const show = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const enabled = computed(() => props.modelValue)
const {isLoading, data} = getSearchTrends({
  enabled
})
const trends = computed(() => data?.value || {})
const search = ref(props.initialValue || '')

const router = useRouter();
const localPath = useLocalePath()
const searchWord = () => {
  track(TRACKERS.SEARCH_TERM, {
    eventLabel: search.value,
    eventAction: 'search_term'
  })
  recentSuggestionWord({term: search.value, search_query: search.value})
  router.push(localPath({path: '/search', query: {q: search.value}}))
  closeSearch()
}
const closeSearch = () => {
  track(TRACKERS.SEARCH_TERM, {
    eventLabel: search.value,
    eventAction: 'close'
  })
  show.value = false
}

const cancelHandler = () => {
  search.value = ''
  closeSearch()
}

const setSearch = (keyword) => {
  search.value = keyword
  searchRef.value = keyword
  closeSearch()
}
</script>
<style scoped>
:deep(.van-field__clear) {
  margin-left: -2rem;
}
</style>